export default [
  {
    path: "ability",
    name: "Ability",
    component: { render: h => h("router-view") },
    permission: "expert_service.api.fuwu_admin.v2.ability.certify.index",
    redirect: { name: "AbilityEvaluationTask" },
    meta: {
      title: "极客-认证评估-能力评估",
      nav: {
        icon: "el-icon-s-data",
        title: "认证评估"
      },
      breadcrumb: {
        title: "认证评估",
        replace: false
      }
    },
    children: [
      {
        path: "task",
        name: "AbilityEvaluationTask",
        permission: "expert_service.api.fuwu_admin.v2.ability.certify.index",
        component: () => import("@/views/Ability/AbilityEvaluationTask.vue"),
        meta: {
          title: "极客-能力评估-评估任务",
          nav: {
            icon: "",
            title: "评估任务"
          },
          breadcrumb: {
            title: "评估任务",
            replace: false
          }
        }
      },
      {
        path: "my/task",
        name: "MyEvaluationTask",
        permission:
          "expert_service.api.fuwu_admin.v2.expert.ability.certify.index",
        component: () => import("@/views/Ability/MyEvaluationTask.vue"),
        meta: {
          title: "极客-能力评估-我的评估",
          nav: {
            icon: "",
            title: "我的评估"
          },
          breadcrumb: {
            title: "我的评估",
            replace: false
          }
        }
      },
      {
        path: "evaluate/:id",
        name: "AbilityEvaluate",
        permission:
          "expert_service.api.fuwu_admin.v2.expert.ability.certify.evaluate",
        component: () => import("@/views/Ability/AbilityEvaluate.vue"),
        meta: {
          title: "极客-能力评估-我的评估-评估任务"
        },
        breadcrumb: {
          title: "评估任务",
          replace: false
        }
      },
      {
        path: "result/:id",
        name: "AbilityEvaluationDetail",
        permission:
          "expert_service.api.fuwu_admin.v2.expert.ability.certify.show",
        component: () => import("@/views/Ability/AbilityEvaluationDetail.vue"),
        meta: {
          title: "极客-能力评估-我的评估-评估结果",
          breadcrumb: {
            title: "评估结果",
            replace: false
          }
        }
      }
    ]
  }
];
